import { render, staticRenderFns } from "./PaymentHistoryTable.vue?vue&type=template&id=74b9080c&scoped=true&"
import script from "./PaymentHistoryTable.vue?vue&type=script&lang=ts&"
export * from "./PaymentHistoryTable.vue?vue&type=script&lang=ts&"
import style0 from "./PaymentHistoryTable.vue?vue&type=style&index=0&id=74b9080c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74b9080c",
  null
  
)

export default component.exports